import { useState } from 'react';
import { AddOrderProductMode } from '../../../products/orderProducts.types';
import { AddOrderProductToggleState, UseAddProductToggleParams } from '../orderObjectPage.types';
import useAddProductTogglePreference from './useAddProductTogglePreference';

const useAddProductToggle = ({
  orderId,
  hasProducts,
  isOfflineMode = false,
}: UseAddProductToggleParams) => {
  const { preference, isPreferenceReady, savePreference } = useAddProductTogglePreference();

  const [interaction, setInteraction] = useState({ orderId, hasUserToggled: false });

  if (interaction.orderId !== orderId) {
    setInteraction({ orderId, hasUserToggled: false });
  }

  const isOpen = preference.isOpen && (hasProducts || interaction.hasUserToggled);
  const isModeSelectable = !isOfflineMode;

  const applyPreference = (nextPreference: AddOrderProductToggleState) => {
    setInteraction({ orderId, hasUserToggled: true });
    savePreference(nextPreference);
  };

  const toggleOpen = () => {
    applyPreference({ ...preference, isOpen: !isOpen });
  };

  const selectMode = (mode: AddOrderProductMode) => {
    applyPreference({ isOpen: true, mode });
  };

  return {
    isOpen,
    mode: isModeSelectable ? preference.mode : AddOrderProductMode.COLOR,
    isModeSelectable,
    isPreferenceReady,
    toggleOpen,
    selectMode,
  };
};

export default useAddProductToggle;
